import { PrivateRoute } from "@rentiohq/web-shared/dist/components";
import { getAuthScene } from "@rentiohq/web-shared/dist/scenes/Auth";
import DashboardStats from "@rentiohq/web-shared/dist/scenes/DashboardStats/DashboardStats";
import DashboardStatsDetail from "@rentiohq/web-shared/dist/scenes/DashboardStats/DashboardStatsDetail";
import Leads from "modules/general/routes/Leads";
import { default as NotFound } from "modules/general/routes/NotFound";
import { Route, Routes } from "react-router-dom";
import { ConnectAuthorize } from "scenes/Connect";
import { App } from "./App";

export const AppRouter = () => {
  return (
    <Routes>
      {getAuthScene()}

      {/* INFO: consent screen of the insurance backoffice MCP connector. Public (outside
          PrivateRoute): it sends a signed-out person through the sign-in itself and comes back
          with the request intact. */}
      <Route path="connect/authorize" element={<ConnectAuthorize />} />

      <Route element={<PrivateRoute />}>
        <Route path="*" element={<App />}>
          <Route path="leads">
            <Route path=":leadId" element={<Leads />} />

            <Route index element={<Leads />} />
          </Route>

          <Route path="stats" element={<DashboardStatsDetail />} />

          <Route index element={<DashboardStats />} />

          <Route path="*" element={<NotFound />} />
        </Route>
      </Route>

      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};
